import {Collapse} from 'antd';
import styles from './performance.module.scss';

/** The approximations the report accepts, in the words an admin needs. */
export const PerformanceHelp = () => (
  <Collapse ghost className={styles.help}>
    <Collapse.Panel header="How these numbers are counted" key="help">
      <ul>
        <li>
          <strong>Resolved</strong> uses each ticket&apos;s current status and
          resolve time. A ticket that is reopened leaves an older period until
          it is resolved again.
        </li>
        <li>
          <strong>Pending now</strong> is live. It is measured at the time
          shown, even when you look at a past period. An agent&apos;s count is
          only tickets active with them (HUMAN_ACTIVE); the team total also
          counts escalated tickets still in the queue, so it can be higher than
          the agents added up.
        </li>
        <li>
          A rating stays with the agent credited for the ticket, also after
          reassignment or reopening.
        </li>
        <li>
          Only human outcomes are credited to an agent. AI, FAQ and
          customer-closed tickets — and any resolved ticket with no credited
          person — are <strong>Unattributed</strong>, and their ratings count in
          the total.
        </li>
        <li>
          Times are plain clock time, overnight and weekends included, with no
          business hours. Older tickets missing a queue timestamp are left out
          of the timings.
        </li>
        <li>
          Averages exclude unrated tickets and tickets with no measured time;
          the total is weighted by every rating, not an average of agents.
        </li>
      </ul>
    </Collapse.Panel>
  </Collapse>
);
